import { baseUrl } from '@/api/client/ApiBase';
import lightTheme from '@/assets/lightTheme.json';
import { ThemeConfig } from '@goalsetter/ant-design-ui';
import {
  AuthLoginPostRequestBodyBff,
  AuthLoginPostResponseBodyBff,
} from '@goalsetter/classroom-types/auth-app';
import { AccountLockoutErrorResponseBody } from '@goalsetter/classroom-types/auth';

const parseLoginResponseBody = (
  payload: unknown,
): AuthLoginPostResponseBodyBff | AccountLockoutErrorResponseBody => {
  if (typeof payload !== 'object' || payload === null) {
    throw new Error('Invalid login response');
  }
  return payload as
    | AuthLoginPostResponseBodyBff
    | AccountLockoutErrorResponseBody;
};

const useConfigApi = () => {
  const getTheme = async (): Promise<ThemeConfig> => {
    await new Promise((resolve) => setTimeout(resolve, 2500));
    return lightTheme as unknown as ThemeConfig;
  };

  const postLogin = async (
    body: AuthLoginPostRequestBodyBff,
  ): Promise<AuthLoginPostResponseBodyBff> => {
    const { identifier, password } = body;
    const url = `${baseUrl()}/api/auth/public/login`;
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        identifier,
        password,
      }),
    });

    const payload = parseLoginResponseBody(await response.json());

    if (!response.ok) {
      throw payload;
    }

    return payload;
  };

  return { getTheme, postLogin };
};

export default useConfigApi;
